const dev = {
    baseURL: 'http://localhost:9317',
    emailURL: 'http://34.197.161.10:7420',
    uploaded_file_url: 'https://d38b1itg3umk0r.cloudfront.net',
    aws_bucket: 'magna-compliance-uploads',
    env: 'uat',
};


const uat = {
    baseURL: 'http://34.197.161.10:9317',
    emailURL: 'http://34.197.161.10:7420',
    uploaded_file_url: 'https://d38b1itg3umk0r.cloudfront.net',
    aws_bucket: 'magna-compliance-uploads',
    env: 'uat',
};

const prod = {
    baseURL: 'https://api.compliancetracer.com',
    emailURL: 'https://tmsemail.api-magnafoodservice.co.uk',
    uploaded_file_url: 'https://d38b1itg3umk0r.cloudfront.net',
    aws_bucket: 'magna-compliance-uploads',
    env: 'prod',
};

module.exports = prod;